import { render, staticRenderFns } from "./wy-analytics-contact-reasons-detail-topic-messages.vue?vue&type=template&id=6886d782&"
import script from "./wy-analytics-contact-reasons-detail-topic-messages.vue?vue&type=script&lang=js&"
export * from "./wy-analytics-contact-reasons-detail-topic-messages.vue?vue&type=script&lang=js&"
import style0 from "./wy-analytics-contact-reasons-detail-topic-messages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports